import { Avatar } from 'ui';
import { SidebarItemButton, SidebarItemIcon, SidebarItemText } from '../../Sidebar/SidebarItem/SidebarItem.styled';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Tooltip } from 'ui';
import { useState } from 'react';

interface IProps {
  open: boolean;
  dropdown: boolean;
  text: string;
  onClick: () => void;
  disabled: boolean;
}

const TenantDropdownButton = ({ open, text, onClick, disabled, dropdown }: IProps) => {
  const [isAvatarTooltipOpen, setIsAvatarTooltipOpen] = useState(false);
  return (
    <SidebarItemButton
      data-testid="btn-master-slave"
      open={open}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: theme => (open ? `${theme.palette.grey[500]}` : 'transparent'),
        p: theme => theme.spacing(1.4, 0.9),
        '&.Mui-disabled': {
          opacity: 1
        }
      }}
    >
      <Tooltip
        placement="right"
        disableHoverListener={open}
        onOpen={() => setIsAvatarTooltipOpen(true)}
        onClose={() => setIsAvatarTooltipOpen(false)}
        open={open ? false : isAvatarTooltipOpen}
        title={text}
      >
        <SidebarItemIcon open={open}>
          <Avatar name={text} />
        </SidebarItemIcon>
      </Tooltip>
      <SidebarItemText
        primaryTypographyProps={{
          noWrap: true,
          color: 'text.primary',
          fontWeight: theme => theme.typography.fontWeightMedium
        }}
        primary={text}
        open={open}
        data-testid="sidebar-site-name"
      />
      <DropDownIndicator open={open} dropdown={dropdown} disabled={disabled} />
    </SidebarItemButton>
  );
};

interface DropDownIndicatorProps {
  open: boolean;
  dropdown: boolean;
  disabled: boolean;
}

const DropDownIndicator = ({ open, dropdown, disabled }: DropDownIndicatorProps) => {
  if (open === false || disabled === true) return null;
  if (dropdown) return <ExpandLessIcon sx={{ color: 'grey.200' }} />;
  else return <ExpandMoreIcon sx={{ color: 'grey.200' }} />;
};

export default TenantDropdownButton;
